import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BsDot } from "react-icons/bs";
function SideBar({ routes }) {
  const { user_type, user } = useSelector(state => state);
  return (
    <div className="side-menu" id="sideMenu">
      <div className="side-menu-body">
        <ul>
          {Menu(user_type, user, routes)}
          <li>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.location.replace("/exiteacount");
              }}
            >
              <span style={{ fontWeight: "400" }}>خروج از حساب</span>{" "}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
const checkActive = (status, route) => {
  switch (status) {
    case "active":
      return route;
    case "dactive":
      return [];
    case "notpassword":
      return route.filter(item => item.path === "/User/setting");
  }
};
const Menu = (UserType, user, RoutesUser) => {
  let Routes = RoutesUser;

  switch (UserType) {
    case "user":
      Routes = checkActive(user.status, RoutesUser);
      break;
    default:
      break;
  }
  const closeSideBar = () => {
    if (window.innerWidth < 992) {
      var element = document.getElementById("sideMenu");
      element.classList.remove("show");
      const overlay = document.getElementById("ela");
      overlay.remove();
    }
  };

  if (Routes) {
    return Routes.map((route, i) => {
      if (!route.subscribe) {
        if (route.sub === "") {
          return (
            <li key={i}>
              <Link
                style={{ fontWeight: "400" }}
                to={route.path}
                onClick={closeSideBar}
              >
                <span>{route.label}</span>
              </Link>
            </li>
          );
        } else {
          return null;
        }
      } else {
        let SubScribes = Routes.filter(item => item.sub === route.name);
        return (
          <li key={i}>
            <Link to={route.path} style={{ fontWeight: "400" }}>
              {/* <i className={route.icon} /> */}
              <span>{route.label}</span>
            </Link>
            <ul key={i}>
              {SubScribes &&
                SubScribes.map((sub, y) => {
                  return (
                    <li
                      key={y}
                      className=""
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <Link
                        to={sub.path}
                        style={{ fontWeight: "400" }}
                        onClick={closeSideBar}
                      >
                        <BsDot size={20} /> <span>{sub.label}</span>{" "}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </li>
        );
      }
    });
  }
};

export default SideBar;
